/** Home (/) with the PvP Arena tab selected — the lobby only exists inside Home, not as a standalone route. */
export const HOME_PVP_ARENA_PATH = '/?tab=pvp';
